<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getRepaymentDetailFactoringsHeaders ()"
    :items="getItems ()"
    :loading="factoringsLoading"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <tr @click="navigateToFactoringDetail(props.item.Id)">
        <td><router-link
          :to="{name: 'Factoring detail', params: {id: props.item.Id}}"
          target="_self">{{ props.item.Id }}</router-link></td>
        <td class="text-xs-left">{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
        <td class="text-xs-left">{{ props.item.Status }}</td>
        <td class="text-xs-left">{{ props.item.FactoringDueDate | date }}</td>
        <td class="text-xs-left">{{ props.item.Capital | amount }}</td>
        <td class="text-xs-left">{{ props.item.LeftToPay | amount }}</td>
        <td class="text-xs-left">{{ props.item.Account | account }}</td>
        <td class="text-xs-left">{{ props.item.InitialTransferAmount | amount }}</td>
        <td class="text-xs-left">{{ props.item.Created | date }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
import EnumIterator from '../helper/EnumIterator';
    export default {
        name: "FactoringsDatagrid",
        components: {DataGridSort},
        props: ['factorings','factoringsLoading','rowsPerPage'],
        data() {
            return {
              pagination:
                      {
                        sortBy: 'id'
                      }
            }
        },
        methods: {
          getRepaymentDetailFactoringsHeaders ()
          {
            return  [
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.id'), value: 'id', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.debtor'), value: 'debtor', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.status'), value: 'status', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.factoringduedate'), value: 'factoringDueDate', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.capital'), value: 'Amount', align: 'left'},
              {sortable: false, text: this.$t('krita.repaymentdetail.factoring.header.lefttopay'), value: 'lefttopay', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.account'), value: 'account', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.initialtransferamount'), value: 'initialtransferamount', align: 'left'},
              {sortable: true, text: this.$t('krita.repaymentdetail.factoring.header.created'), value: 'created', align: 'left'},
            ]
          },
          getItems ()
          {
            let self = this;

            let items = [];

            for (let row of self.factorings)
            {
              let factoringsRowClient = {
                APR: row.APR,
                Account: row.Account,
                Capital: row.Capital,
                Created: row.Created,
                DebtorName: row.DebtorName,
                DebtorRegistryId: row.DebtorRegistryId,
                DueDate: row.DueDate,
                FactoringDueDate: row.FactoringDueDate,
                FeeAmount: row.FeeAmount,
                Id: row.Id,
                InitialTransferAmount: row.InitialTransferAmount,
                LastPaymentDate: row.LastPaymentDate,
                LeftToPay: row.LeftToPay,
                Status: self.$t(EnumIterator.processFactoringStatus(row.Status)),
              };
              items.push(factoringsRowClient);
            }
            return items;
          },
          navigateToFactoringDetail (id)
          {
              this.$router.push('/factoring/' + id);
          },
          changeSort (sort)
          {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
          }
        }
    }
</script>

<style scoped>

</style>
